import React from 'react';
import {
	Text, ActivityIndicator, View, TouchableOpacity
} from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import { Ionicons } from '@expo/vector-icons';

import styles from './styles';
import capitalize from '../../utils/capitalize';

function Control({
	title, children, onPress, theme, loading = false, icon, small, disabled = false
}) {
	return (
		<TouchableOpacity
			style={[
				styles.control,
				theme && styles[`control${theme}`],
				loading && styles.controlLoading,
				theme && loading && styles[`controlLoading${theme}`],
				small && styles.controlSmall,
			]}
			delayPressIn={0}
			onPress={loading ? null : onPress}
			underlayColor={EStyleSheet.value('$blueDark')}
			disabled={disabled}
		>
			<View style={styles.innerControl} accessible>
				{loading ? (
					<ActivityIndicator size="small" color={EStyleSheet.value('$white')} />
				) : (
					<>
						{icon && <Ionicons name={icon} style={[styles.icon, theme && styles[`icon${theme}`]]} />}
						<Text style={[styles.text, theme && styles[`text${theme}`]]}>{capitalize(children || title)}</Text>
					</>
				)}

			</View>
		</TouchableOpacity>
	);
}

export default Control;
